import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import React, {useEffect, useState} from "react";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserProfileDetailPage from "../../component/userProfileDetail/UserProfileDetailPage";
import ChangePasswordCardComponent from "../../component/changePassword/ChangePasswordCardComponent";
import {useNavigate, useParams} from "react-router-dom";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {css} from "@emotion/css";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridOneColumn, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export const ManagerDetail = () => {

    const loading = useLoadingDispatcher()

    const {id: managerId = -1} = useParams()

    const service = new ManagerService()

    const [profileDetail, setProfileDetail] = useState({});
    const [adminName, setAdminName] = useState("جزئیات حساب");

    const [avatar, setAvatar] = useState("");

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setAdminName(`${profileDetail.firstName} ${profileDetail.lastName}`)
        }
    }, [profileDetail])


    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [])


    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getProfileDetailById(managerId)
            .then(response => {
                setProfileDetail(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading(setLoadingStateDispatch(false))
        })

        service.getManagerAvatar(managerId)
            .then(response => {
                setAvatar(response.downloadUrl)
            }).catch(reason => {

        })
    }


    const [value, setValue] = useState(ManagerTabTypes.ProfileContent.id);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function doChangePassword() {

    }

    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title className="">{RouteInfo.Profile.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    "مدیریت",
                                    RouteInfo.ManagersList.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    RouteInfo.ManagersList.name,
                                    RouteInfo.ManagersList.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    adminName,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(RouteHelper.ManagersList.globalUrl)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>


                    <TabContext value={value}>
                        <TabBoxContainer>
                            <TabList onChange={handleChange} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon" className={"ic-profile"}/>} iconPosition="start"
                                     label={ManagerTabTypes.ProfileContent.title}
                                     value={ManagerTabTypes.ProfileContent.id}/>
                                <Tab icon={<div id="tabIcon" className={"ic-security"}/>} iconPosition="start"
                                     label={ManagerTabTypes.Password.title}
                                     value={ManagerTabTypes.Password.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={ManagerTabTypes.ProfileContent.id}>
                            <UserProfileDetailPage
                                adminId={managerId}
                                profileDetail={profileDetail}
                                setProfileDetail={setProfileDetail}
                                service={service}
                                avatarFile={avatar}
                                setAvatarFile={setAvatar}
                            />
                        </TabPanel>
                        <TabPanel value={ManagerTabTypes.Password.id}>
                            <ChangePasswordCardComponent
                                adminId={managerId}
                                service={service}
                                doChangePassword={doChangePassword}
                            />
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>


    )
}

const ManagerTabTypes = {
    ProfileContent: {
        id: "profile-content",
        title: "جزئیات حساب"
    },
    Password: {
        id: "password",
        title: "رمز عبور"
    },
}